import styled from 'styled-components';
import BaseMarkerIcon from '#/shared/components/GeneratedIcons/trimet/MapMarkerSolid';
import { CurrentLocationMarker } from '#/map/components/CurrentLocationOverlay';
import {
  ORIGIN_LOCATION_TYPE,
  DESTINATION_LOCATION_TYPE,
} from '#/shared/constants';

export const EndpointIcon = styled(BaseMarkerIcon).attrs(
  ({ theme, $locationType }) => ({
    role: 'presentation',
    height: 30,
    width: 30,
    fill:
      ($locationType === ORIGIN_LOCATION_TYPE && theme.originColor) ||
      ($locationType === DESTINATION_LOCATION_TYPE && theme.destinationColor) ||
      null,
  })
)``;

export const MapEndpointIcon = styled(EndpointIcon)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -100%);
`;

export const CurrentLocationBadge = styled(CurrentLocationMarker).attrs({
  size: 16,
})``;
